import { FormikErrors } from 'formik'
import { defaultValidators } from '$utils/formValidators'
import { CustomerRegistrationFormValues } from './CustomerRegisterForm.model'

export const validateName = (name: string) => {
  if (!defaultValidators.required(name)) {
    return 'Nombre obligatorio'
  }

  if (!defaultValidators.isValidName(name)) {
    return 'El nombre debe tener solo letras'
  }

  if (!defaultValidators.atLeastThreeCharacters(name)) {
    return 'El nombre es demasiado breve: debe tener al menos tres caracteres'
  }

  return undefined
}

export const validatePhone = (phone: string) => {
  if (!defaultValidators.required(phone)) {
    return 'Telefono móvil obligatorio'
  }
  if (!defaultValidators.isValidPhoneNumber(phone)) {
    return 'El teléfono móvil no es válido: tiene que ser una combinación de números'
  }
  if (phone.length !== 9) {
    return 'Introduce un nº de teléfono de 9 cifras, sin prefijos ni otros caracteres. Ej. 600102030'
  }
  return undefined
}

export const validateEmail = (email: string) => {
  if (!defaultValidators.required(email)) {
    return 'Email obligatorio'
  }

  if (!defaultValidators.isValidEmail(email)) {
    return 'El email no es valido'
  }

  return undefined
}

export const validatePassword = (password: string) => {
  if (!defaultValidators.required(password)) {
    return 'Contraseña obligatoria'
  }

  if (!defaultValidators.passwordHasValidLength(password)) {
    return 'La contraseña debe tener entre 6 y 20 caracteres'
  }

  return undefined
}

export const validateCheckPassword = (password: string, checkPassword: string) => {
  if (!defaultValidators.required(checkPassword)) {
    return 'Campo obligatorio'
  }

  if (!(password === checkPassword)) {
    return 'Ambas contraseñas no coinciden'
  }

  return undefined
}

export const validateFieldForm = (formValueFields: CustomerRegistrationFormValues) => {
  let error
  let errors: FormikErrors<CustomerRegistrationFormValues> = {}

  error = validateName(formValueFields.name)
  if (error) errors.name = error
  error = validateEmail(formValueFields.email)
  if (error) errors.email = error
  error = validatePassword(formValueFields.password)
  if (error) errors.password = error
  error = validateCheckPassword(formValueFields.password, formValueFields.checkPassword)
  if (error) errors.checkPassword = error

  return errors
}



// WEBPACK FOOTER //
// ./src/views/components/Forms/CustomerRegisterForm/CustomerRegisterForm.validators.ts